import { Injectable } from '@angular/core';
import { format } from 'date-fns';
import { BaseProxy } from '../base.proxy';

@Injectable()
export class FundTransactionProxy extends BaseProxy {
    GetInvestorTransactions(dealId: number, mcpId: number, startTime: Date, endTime: Date) {
        return this._http.get<any>(`/ip/api/fund/${dealId}/investor/${mcpId}/transaction`, {
            params: {
                startTime: this.getDateStr(startTime),
                endTime: this.getDateStr(endTime),
            }
        });
    }

    GetDealTransactionColumns(dealId: number) {
        return this._http.get<any[]>(`/ip/api/fund/${dealId}/transaction/column`);
    }
}
